<script setup>
import { useI18n } from 'vue-i18n';
import { OnClickOutside } from '@vueuse/components';
import NextButton from 'dashboard/components-next/button/Button.vue';
import MultiselectDropdownItems from 'shared/components/ui/MultiselectDropdownItems.vue';
import { usePopoverTrigger } from '../composables/usePopoverTrigger';

// ALTOS (revisor-frontend, T3.4): substitui o <select> nativo (destoava dos
// NextButton xs da barra de filtros logo abaixo — 40px x 14px contra 24px,
// artefato de seta sobre a primeira letra) e resolve a duplicação com o h1
// (que mostrava o MESMO nome do funil truncado ao lado do <select> exibindo
// tudo). O rótulo do gatilho é fixo ("Funnel"), não repete o nome do funil
// selecionado — quem quer o nome completo já tem o h1 (com :title agora).
// Mesmo padrão local de KanbanPeriodFilter.vue/KanbanMultiSelectFilter.vue:
// MultiselectDropdownItems + OnClickOutside.
const props = defineProps({
  funnels: { type: Array, required: true },
  modelValue: { type: Number, default: null },
});

const emit = defineEmits(['update:modelValue']);

const { t } = useI18n();

const {
  isOpen,
  triggerRef,
  toggle: toggleOpen,
  close,
  closeAndFocusTrigger,
} = usePopoverTrigger();

const options = () =>
  props.funnels.map(funnel => ({ id: funnel.id, name: funnel.name }));

// Escolher um funil desmonta o botão da opção junto com o painel: sem
// devolver o foco ao gatilho, ele cai em BODY (mesmo defeito que o "Move to
// stage" do card já resolvia e que este componente não implementava).
const select = funnel => {
  emit('update:modelValue', funnel.id);
  closeAndFocusTrigger();
};
</script>

<template>
  <OnClickOutside @trigger="close">
    <div class="relative shrink-0">
      <NextButton
        ref="triggerRef"
        slate
        ghost
        xs
        trailing-icon
        :icon="isOpen ? 'i-lucide-chevron-up' : 'i-lucide-chevron-down'"
        :label="t('KANBAN.BOARD.FUNNEL_SWITCH_LABEL')"
        aria-haspopup="true"
        :aria-expanded="isOpen"
        @click="toggleOpen"
      />
      <div
        v-if="isOpen"
        class="absolute z-30 mt-1 w-56 rounded-lg border border-n-weak bg-n-solid-2 shadow-lg p-2"
        @keyup.esc="closeAndFocusTrigger"
      >
        <MultiselectDropdownItems
          :options="options()"
          :selected-items="[{ id: modelValue }]"
          :has-thumbnail="false"
          :input-placeholder="t('KANBAN.BOARD.MULTISELECT.SEARCH_PLACEHOLDER')"
          :no-search-result="t('KANBAN.BOARD.MULTISELECT.NO_RESULTS')"
          @select="select"
        />
      </div>
    </div>
  </OnClickOutside>
</template>
